export default __webpack_public_path__ + "static/634-5bd1daf9abac0c21a47ef2c0279673a2.gif";